import styled from "styled-components";
import { COLORS } from "../../../layout/theme";

export const Page = styled.div`
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px 16px;
	background: #f4f5f7;
	position: relative;
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		background-image:
			radial-gradient(
				circle at 20% 20%,
				rgba(24, 95, 165, 0.06) 0%,
				transparent 50%
			),
			radial-gradient(
				circle at 80% 80%,
				rgba(27, 58, 107, 0.05) 0%,
				transparent 50%
			);
		pointer-events: none;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		background-image: radial-gradient(circle, #cbd5e1 1px, transparent 1px);
		background-size: 28px 28px;
		opacity: 0.35;
		pointer-events: none;
	}
`;

export const Main = styled.div`
	position: relative;
	z-index: 1;
	width: 100%;
	max-width: 980px;
	display: flex;
	flex-direction: column;
	align-items: center;
	animation: fadeUp 0.4s ease both;

	@keyframes fadeUp {
		from {
			opacity: 0;
			transform: translateY(16px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const LogoWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 28px;
`;

export const Header = styled.div`
	width: 100%;
	background: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-radius: 16px 16px 0 0;
	border-bottom: none;
	padding: 30px 32px 0;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

	@media only screen and (max-width: 520px) {
		padding: 24px 20px 0;
	}
`;

export const HeaderTitle = styled.h1`
	font-size: 24px;
	font-weight: 600;
	color: #111827;
	letter-spacing: -0.03em;
	margin: 0 0 6px 0;
`;

export const HeaderDesc = styled.p`
	font-size: 13px;
	color: #6b7280;
	line-height: 1.5;
	margin: 0 0 24px 0;
`;

export const Body = styled.div`
	width: 100%;
	background-color: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-top: none;
	border-radius: 0 0 16px 16px;
	padding: 0 32px 32px;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

	.ant-form {
		width: 100%;
	}

	.ant-form-item {
		margin-bottom: 14px;
	}

	.ant-form-item-explain-error {
		font-size: 12px;
	}

	.ant-input,
	.ant-input-affix-wrapper,
	.ant-select-selector,
	.ant-picker {
		min-height: 42px !important;
		background: #f8f9fa !important;
		border: 1px solid #e4e6ea !important;
		border-radius: 8px !important;
		box-shadow: none !important;
	}

	.ant-input-affix-wrapper .ant-input {
		min-height: auto !important;
		background: transparent !important;
		border: none !important;
	}

	.ant-input:focus,
	.ant-input-focused,
	.ant-input-affix-wrapper:focus,
	.ant-input-affix-wrapper-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select-selector:focus,
	.ant-picker-focused {
		border-color: #185fa5 !important;
		background: #ffffff !important;
		box-shadow: 0 0 0 3px rgba(24, 95, 165, 0.1) !important;
	}

	.ant-input-prefix,
	.ant-input-password-icon,
	.ant-select-arrow {
		color: #9ca3af;
	}

	.ant-checkbox-wrapper {
		font-size: 13px;
		color: #374151;
	}

	.ant-checkbox-inner {
		border-radius: 5px;
	}

	@media only screen and (max-width: 520px) {
		padding: 0 20px 24px;
	}
`;

export const InnerForm = styled.div`
	.ant-row {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}

	.ant-col:first-child {
		padding-left: 0 !important;
	}

	.ant-col:last-child {
		padding-right: 0 !important;
	}

	@media only screen and (max-width: 900px) {
		.ant-row {
			row-gap: 10px;
		}
	}
`;

export const SectionCard = styled.div`
	border: 1px solid #eef2f7;
	background: #fbfcfd;
	border-radius: 14px;
	padding: 18px 18px 6px;
	margin-bottom: 18px;
`;

export const SectionTitle = styled.div`
	font-size: 14px;
	font-weight: 700;
	color: #1b3a6b;
	margin-bottom: 14px;
	letter-spacing: -0.01em;
`;

export const Footer = styled.div`
	margin-top: 18px;
	text-align: center;
	font-size: 12px;
	color: #9ca3af;
	line-height: 1.5;

	a {
		color: #185fa5;
		text-decoration: none;
		font-weight: 500;
	}

	a:hover {
		text-decoration: underline;
	}
`;

export const SecondaryLink = styled.div`
	text-align: center;
	margin-top: 10px;

	a {
		font-size: 12px;
		color: #185fa5;
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}
`;

export const TrustRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	flex-wrap: wrap;
	margin-top: 22px;
`;

export const TrustItem = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 11px;
	color: #9ca3af;
`;

export const TrustDot = styled.div`
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background: #b0b7c3;
`;

export const PrimaryButtonWrap = styled.div`
	.ant-btn {
		width: 100%;
		height: 44px;
		border-radius: 8px;
		border: none;
		background: #1b3a6b;
		box-shadow: 0 2px 8px rgba(27, 58, 107, 0.2);
		font-size: 14px;
		font-weight: 500;
	}

	.ant-btn:hover,
	.ant-btn:focus,
	.ant-btn:active {
		background: #152e56 !important;
		color: white !important;
		border: none !important;
		box-shadow: 0 4px 12px rgba(27, 58, 107, 0.28);
	}
`;
